var _path, _g, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInternational(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1.2628,
    y: -1.2628,
    width: 17.3191,
    height: 17.3191
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.13px)",
      clipPath: "url(#bgblur_0_11877_11124_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 2.2628,
    d: "M13.7935 7.39676C13.7935 10.9297 10.9297 13.7935 7.39676 13.7935C3.86383 13.7935 1 10.9297 1 7.39676C1 3.86447 3.86383 1 7.39676 1C10.9297 1 13.7935 3.86447 13.7935 7.39676Z",
    fill: "url(#paint0_linear_11877_11124)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_11877_11124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4959 7.39091C11.4959 9.64045 9.67243 11.4639 7.42289 11.4639C5.17335 11.4639 3.34985 9.64045 3.34985 7.39091C3.34985 5.14178 5.17335 3.31787 7.42289 3.31787C9.67243 3.31787 11.4959 5.14178 11.4959 7.39091Z",
    fill: "#FF3949"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -0.8452,
    y: -0.844955,
    width: 21.4966,
    height: 21.4966
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.09px)",
      clipPath: "url(#bgblur_1_11877_11124_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4.17747,
    d: "M9.90283 3.41943C13.4837 3.41943 16.3871 6.32261 16.3872 9.90283C16.3872 13.4838 13.4838 16.3872 9.90283 16.3872C6.32196 16.3871 3.41943 13.4837 3.41943 9.90283C3.41958 6.3227 6.32205 3.41958 9.90283 3.41943Z",
    fill: "#FF5563",
    fillOpacity: 0.35,
    stroke: "url(#paint1_linear_11877_11124)",
    strokeWidth: 0.174061,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6001 10L10.0001 10L15.4001 10",
    stroke: "url(#paint2_linear_11877_11124)",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5501 4.06006C7.51261 5.93784 4.66014 10.9067 9.5501 15.7601",
    stroke: "url(#paint3_linear_11877_11124)",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4501 4.06006C12.4876 5.93784 15.3401 10.9067 10.4501 15.7601",
    stroke: "url(#paint4_linear_11877_11124)",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_11877_11124_clip_path",
    transform: "translate(1.2628 1.2628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7935 7.39676C13.7935 10.9297 10.9297 13.7935 7.39676 13.7935C3.86383 13.7935 1 10.9297 1 7.39676C1 3.86447 3.86383 1 7.39676 1C10.9297 1 13.7935 3.86447 13.7935 7.39676Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_11877_11124",
    x: 0.390809,
    y: 0.358826,
    width: 14.0641,
    height: 14.0641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.47952,
    result: "effect1_foregroundBlur_11877_11124"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_11877_11124_clip_path",
    transform: "translate(0.8452 0.844955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.90283 3.41943C13.4837 3.41943 16.3871 6.32261 16.3872 9.90283C16.3872 13.4838 13.4838 16.3872 9.90283 16.3872C6.32196 16.3871 3.41943 13.4837 3.41943 9.90283C3.41958 6.3227 6.32205 3.41958 9.90283 3.41943Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11877_11124",
    x1: 8.33861,
    y1: 8.25346,
    x2: 2.50867,
    y2: 11.1282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5563"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11877_11124",
    x1: 5.54287,
    y1: 4.99681,
    x2: 13.7038,
    y2: 15.1043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11877_11124",
    x1: 10.0001,
    y1: 10,
    x2: 10.0001,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC2C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11877_11124",
    x1: 8.2001,
    y1: 4.06006,
    x2: 8.2001,
    y2: 15.7601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC2C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11877_11124",
    x1: 11.8001,
    y1: 4.06006,
    x2: 11.8001,
    y2: 15.7601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC2C5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternational);
export default __webpack_public_path__ + "static/media/international.94efdc08784595c12eb430ec8f8cacef.svg";
export { ForwardRef as ReactComponent };